import React from 'react';

const Whyhireme = () => {
    return (
      <div
        id="hireme"
        className="sm:pl-[8rem] p-8 mx-7 mt-4 sm:mt-0 sm:pt-16 pb-20 sm:px-4 sm:py-"
      >
        <h1 className="w-72 mb-4 tracking-wider font-semibold text-2xl sm:text-2xl md:text-2xl lg:text-2.5xl sm:mb-4 sm:w-full">
          Why Should you hire me?
        </h1>
      </div>
    );
};

export default Whyhireme;